<template>
  <section class="c-result-section flex flex-col gap-2">
    <header class="c-result-section__header flex items-center gap-4 justify-between">
      <div class="flex items-center gap-2 truncate">
        <CIcon :icon="icon" :size="12" />
        <strong class="title__text truncate">{{ title }} ({{ quantity }})</strong>
      </div>

      <span class="align-right truncate">
        {{ t('canvasUI.CGlobalSearch.foundIn') }}
        <strong>{{ scope }}</strong>
      </span>
    </header>

    <div class="flex flex-col gap-2">
      <slot />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'

interface Props {
  icon: string
  title: string
  scope: string
  quantity: number
}

defineProps<Props>()

const { t } = useI18n()
const themeVars = useThemeVars()
</script>

<style lang="scss" scoped>
.c-result-section {
  &__header {
    color: v-bind('themeVars.text3');
    font-size: 12px;
  }
}

.title {
  &__text {
    font-size: 15px;
    color: v-bind('themeVars.text');
  }
}
</style>
